import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify'
import api from 'api/api'

import './usuarios.css'

import { API_URL, DEFAULT_FETCH_CUANTOS } from 'config/general'
import { debounce } from 'utils/debounce'
import ListaUsuarios from './ListaUsuarios'
import NuevoUsuario from './NuevoUsuario'
import EditarUsuario from './EditarUsuario'
import EliminarUsuario from './EliminarUsuario'
import { UserDetails } from 'components/User'
import TopHeader from 'components/TopHeader'
import { DownloadButton } from 'components/DownloadButton'

function Usuarios(props) {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [pathPlanillaClientes, setPathPlanillaClientes] = useState(API_URL + 'a/reportes/clientes')
	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [usuarios, setUsuarios] = useState([])
	const [tipos, setTipos] = useState([])
	const [accionActual, setAccionActual] = useState({
		usuario: null,
		accion: ''
	})

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshConfig = async () => {
		try {
			const { datos: respuesta } = await api.get('a/cuentas-tipos')
			setTipos(respuesta)
		} catch (error) {
			toast.error('Error ')
		}
	}

	const refreshUsuarios = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('a/ver-usuarios', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					usuario: [filtroBusqueda],
					nombre: [filtroBusqueda]
				}
			})

			setUsuarios(datos.usuarios)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshUsuarios()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshUsuarios()
		}
	}, [paginaAct])

	const nuevoUsuario = async (data) => {
		try {
			const { msg } = await api.post('a/usuarios', data)
			refreshConfig()
			refreshUsuarios()
			cerrarAccion()
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarUsuario = async (data) => {
		if (Object.keys(data).length) {
			const enviar = {
				...data,
				usuarioId: accionActual.usuario.id
			}

			try {
				const { msg } = await api.put('a/usuarios/' + accionActual.usuario.id, enviar)
				refreshConfig()
				refreshUsuarios()
				cerrarAccion()
				toast.success(msg)
			} catch (error) {
				console.error(error)
				toast.error('Error de conexión')
			}
		}
	}

	const eliminarUsuario = async (id) => {
		const { msg } = await api.delete('a/usuarios/' + id)
		refreshConfig()
		refreshUsuarios()
		cerrarAccion()
		toast.success(msg)
	}

	useEffect(() => {
		if (!loading) {
			refreshConfig()
			refreshUsuarios()
		}
	}, [])

	// Las acciones específicas para la lista de usuarios
	const accionesActuales = {
		handleVer: (usuario) => {
			setAccionActual({
				usuario,
				accion: 'ver'
			})
		},
		handleEditar: (usuario) => {
			setAccionActual({
				usuario,
				accion: 'editar'
			})
		},
		handleEliminar: (usuario) => {
			setAccionActual({
				usuario,
				accion: 'eliminar'
			})
		},
	}

	const cerrarAccion = () => {
		setAccionActual({
			usuario: {},
			accion: ''
		})
	}

	const descargarExcel = async () => {
		try {
			// Usar tu instancia de API que ya tiene la autenticación configurada
			const response = await api.get(pathPlanillaClientes, {
				responseType: 'blob' // Importante para archivos
			})

			// Con responseType: 'blob', axios devuelve la respuesta directamente en response.data
			// No en response.datos como tu interceptor normal
			const blob = new Blob([response.data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			})

			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.download = 'clientes.xlsx' // Nombre del archivo
			document.body.appendChild(link)
			link.click()

			// Limpiar
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)

			toast.success('Excel descargado correctamente')
		} catch (error) {
			console.error('Error al descargar Excel:', error)
			toast.error('Error al descargar el archivo')
		}
	}


	// render
	return (
		<Container fluid id="usuarios" className="vh-100">
			<TopHeader
				iconName="users"
				text="Clientes"
			/>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">usuarios</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col className="d-flex justify-content-between align-items-center">
					<Button
						variant="primary"
						onClick={() => setAccionActual({
							usuarioId: null,
							accion: 'nuevo'
						})}
						className="mt-2"
					>
						<i className="fa fa-plus"></i> Nuevo
					</Button>

					{pathPlanillaClientes && (
						<DownloadButton
							url={API_URL + 'a/reportes/clientes'}
							whileDownloading={<i className="fa fa-spinner fa-spin"></i>}
							variant="action2"
							className="btn btn-success me-1"
							title="Descargar Excel"
						>
							<i className="fa fa-file-excel"></i> Descargar Excel
						</DownloadButton>
					)}
				</Col>
			</Row>
			{/* Lista usuarios */}
			<ListaUsuarios
				loading={loading}
				usuarios={usuarios}
				numResultados={numResultados}
				pagina={paginaAct}
				fetchDeACuantos={fetchDeACuantos}
				cambiarPagina={setPaginaAct}
				acciones={accionesActuales}
			/>
			{/* Panel Nuevo */}
			<NuevoUsuario
				mostrar={accionActual.accion === 'nuevo'}
				guardar={nuevoUsuario}
				cancelar={cerrarAccion}
				tiposDisponibles={tipos}
				tipoFijo="cliente"
			/>
			{/* Panel Ver */}
			<UserDetails
				mostrar={accionActual.accion === 'ver'}
				usuario={accionActual.usuario}
				cancelar={cerrarAccion}
				tiposDisponibles={tipos}
			/>
			{/* Panel Editar */}
			<EditarUsuario
				mostrar={accionActual.accion === 'editar'}
				usuarioOriginal={accionActual.usuario}
				cancelar={cerrarAccion}
				guardar={editarUsuario}
				tiposDisponibles={tipos}
				tipoFijo="cliente"
			/>
			{/* Modal Delete */}
			<EliminarUsuario
				mostrar={accionActual.accion === 'eliminar'}
				usuario={accionActual.usuario}
				cancelar={cerrarAccion}
				eliminar={eliminarUsuario}
			/>
		</Container>
	);
}

export default Usuarios